module.exports = __webpack_public_path__ + "img/close-chat.50c95a4e.svg";